import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";
import { CircleCheck, CircleX, Info, TriangleAlert } from "lucide-react";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * Duração padrão do toast (ms). A barra de progresso é animada em CSS com a
 * mesma duração via `--toast-duration` (ver index.css) — se um toast usar uma
 * duração diferente, passe também `style={{ '--toast-duration': '6s' }}`.
 */
export const TOAST_DURATION = 5000;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      duration={TOAST_DURATION}
      closeButton
      icons={{
        success: <CircleCheck strokeWidth={2} />,
        error: <CircleX strokeWidth={2} />,
        warning: <TriangleAlert strokeWidth={2} />,
        info: <Info strokeWidth={2} />,
      }}
      toastOptions={{
        classNames: {
          toast: "group toast",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
